import { Loading } from '@/components/Loading';
import type { RolePlayResultFragment } from '@/gql/codegen/graphql';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import { EvaluationMark } from '../../../-components/EvaluationMark';
import styles from './index.module.scss';

export type EvaluationDetailsProps = {
  items: RolePlayResultFragment['evaluationItemsWithResults'];
  isEvaluated: boolean;
};

const EvaluationDetail: React.FC<{
  item: RolePlayResultFragment['evaluationItemsWithResults'][number];
  isEvaluated: boolean;
}> = ({ item, isEvaluated }) => {
  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemHeader}>
        <h3 className={styles.itemTitle}>{item.title}</h3>
        <div className={styles.evaluationMarks}>
          <div className={styles.markGroup}>
            <span className={styles.markLabel}>ファースト</span>
            <EvaluationMark
              isPassed={item.firstResultEvaluationItem?.isPassed}
              size={32}
            />
          </div>
          <div className={styles.markGroup}>
            <span className={styles.markLabel}>セカンド</span>
            <EvaluationMark
              isPassed={item.secondResultEvaluationItem?.isPassed}
              size={32}
            />
          </div>
        </div>
      </div>

      {isEvaluated ? (
        <div className={styles.feedbackContainer}>
          {item.currentResultEvaluationItem.positiveFeedback && (
            <div className={styles.positiveFeedback}>
              <h4 className={styles.feedbackTitle}>良かった点</h4>
              <div className={styles.markdown}>
                <ReactMarkdown remarkPlugins={[remarkBreaks]}>
                  {item.currentResultEvaluationItem.positiveFeedback}
                </ReactMarkdown>
              </div>
            </div>
          )}
          {item.currentResultEvaluationItem.improvementFeedback && (
            <div className={styles.improvementFeedback}>
              <h4 className={styles.feedbackTitle}>改善点</h4>
              <div className={styles.markdown}>
                <ReactMarkdown remarkPlugins={[remarkBreaks]}>
                  {item.currentResultEvaluationItem.improvementFeedback}
                </ReactMarkdown>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className={styles.loadingContainer}>
          <Loading />
        </div>
      )}
    </div>
  );
};

export const EvaluationDetails: React.FC<EvaluationDetailsProps> = ({
  items,
  isEvaluated,
}) => {
  return (
    <div className={styles.container}>
      {items.map((item) => (
        <React.Fragment key={item.id}>
          <EvaluationDetail item={item} isEvaluated={isEvaluated} />
          <div className={styles.divider} />
        </React.Fragment>
      ))}
    </div>
  );
};
